import {
  CreateAgencyCustomerRequestBodyType,
  CreateAgencyCustomerResponseBodyType,
} from "@intelligems/ig-types";
import { adminKeys } from "@src/api/queryKeys";
import { ApiRequest } from "@src/api/types/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";

const createAgencyCustomer = async (
  data: ApiRequest<CreateAgencyCustomerRequestBodyType>
) => {
  const resp = await api.post<CreateAgencyCustomerResponseBodyType>(
    `/v2/admin/customers`,
    {
      ...data.body,
    }
  );
  return resp.data;
};

export const useCreateAgencyCustomer = () => {
  const queryClient = useQueryClient();
  return useMutation<
    CreateAgencyCustomerResponseBodyType,
    Error,
    ApiRequest<CreateAgencyCustomerRequestBodyType>,
    any
  >({
    mutationFn: async (data) => createAgencyCustomer(data),
    onSuccess: async (data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: adminKeys.agency(variables.body.customer.agencyId),
      });
    },
  });
};
